export default {
    technicalReports: [],
    technicalReportStatus: [],
    technicalReportDetails: {},
    technicalReportComments: [],
}